import React from 'react';

const Sustainability = () => (
    <div>
        <h2>Sustainability Page</h2>
    </div>
);

export default Sustainability;
